import styled, { css } from 'styled-components';
import { marginStyles } from '../../styles/components.js';
import { mapFontSize, isMobileHeading, mapMobileHeadingFontSize } from './text.utils.js';

const paragraphStyles = (props) => css `
  font-size: ${mapFontSize(props.textStyle, props.theme)};
  font-family: ${props.theme.fontFamilies.main.regular};
  text-align: ${props.textAlign};
  line-height: ${props.theme.lineHeights.large};
  color: ${props.theme.colors.content[props.color]};
  opacity: ${props.theme.opacities[props.opacity]};
  -webkit-font-smoothing: antialiased;

  ${marginStyles(props.margin)};
`;
const headingStyles = (props) => css `
  font-size: ${isMobileHeading(props.textStyle) &&
    mapMobileHeadingFontSize(props.textStyle, props.theme)};
  font-family: ${props.theme.fontFamilies.main.medium};
  text-align: ${props.textAlign};
  line-height: ${props.theme.lineHeights.medium};
  color: ${props.theme.colors.content[props.color]};
  opacity: ${props.theme.opacities[props.opacity]};
  -webkit-font-smoothing: antialiased;

  ${marginStyles(props.margin)};

  ${props.theme.media.tabletPortraitUp} {
    font-size: ${mapFontSize(props.textStyle, props.theme)};
  }
`;
const eyebrowStyle = (props) => css `
  font-size: ${mapFontSize(props.textStyle, props.theme)};
  font-family: ${props.theme.fontFamilies.main.medium};
  text-align: ${props.textAlign};
  line-height: ${props.theme.lineHeights.small};
  color: ${props.theme.colors.content[props.color]};
  letter-spacing: 0.07em;
  text-transform: uppercase;
  -webkit-font-smoothing: antialiased;

  ${marginStyles(props.margin)};
`;
const styles = (props) => {
    if (props.textStyle.includes('heading')) {
        return headingStyles;
    }
    if (props.textStyle.includes('eyebrow')) {
        return eyebrowStyle;
    }
    return paragraphStyles;
};
const P = styled.p `
  ${styles}
`;
const H1 = styled.h1 `
  ${styles}
`;
const H2 = styled.h2 `
  ${styles}
`;
const H3 = styled.h3 `
  ${styles}
`;
const H4 = styled.h4 `
  ${styles}
`;
const H5 = styled.h5 `
  ${styles}
`;
const H6 = styled.h6 `
  ${styles}
`;

export { H1, H2, H3, H4, H5, H6, P };
